<!-- Hero starts -->
<section class="ilite-hero">
    <div class="container customcontainer">
        <div class="row row-flex">
            <div class="col-lg-5 col-md-12 col-sm-12 col-xs-12">
                <div class="ilite-imgcenter">
                    <figure>
                        <img src="assets/img/heroboy.png" alt="">
                    </figure>
                </div>
            </div>
            <div class="col-lg-7 col-md-12 col-sm-12 col-xs-12">
                <div class="ilite-herocontent">
                    <div>
                        <figure>
                            <img src="assets/img/herostamp.png" class="herostamp" alt="">
                        </figure>
                    </div>
                    <h1 class="IL_ilite-add-suc">We add <span class="ilite-success">success</span> to your Preparation!</h1>
                    <h2 class="IL_ilite-hn-sclr">Get upto <span class="ilite-scholar">100% scholarship</span> and</h2>
                    <h3 class="IL_ilite-prizes">prizes worth 10cr.*</h3>
                    <p>Biggest Scholarship exam for <strong>NEET and JEE Main & Advanced</strong></p>
                    <div>
                        <div class="input-group cts-ilite">
                            <div class="input-group-prepend">
                                <span class="input-group-text border-10">+91</span>
                            </div>
                            <input maxlength="10" type="text" class="ASM_no-box-shadow form-control cts-inputilite" placeholder="Mobile Number" [(ngModel)]="mobileNumber" />
                            <button  (click)="signup('ilite', {number: mobileNumber, dialCode: '+91'})"  type="button" class="ilitehero-btn" ><b>REGISTER NOW</b><img
                                    src="assets/img/btnright.png" alt=""></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Hero ends -->

<!-- eligible starts -->
<section class="ilite-whoareeligible">
    <div class="container customcontainer">
        <div class="eligible-head">
            <h1>Pick the <span class="ilite-eligible">right test </span>for you!</h1>
            <p>Looking for scholarship to prepare for NEET , JEE Main & Advanced, you are at the right place
                <br>Get ready to prepare online with top faculties from Infinity Learn by Sri Chaitanya to help you
                achieve top ranks across India.
            </p>
        </div>
        <div class="row">
            <div class="col-lg-12 col-md-12 col-xs-12">
                <div class="tab" role="tabpanel">
                    <div class="quotes-center">
                        <!-- Nav tabs -->
                        <ul class="nav nav-tabs right-center" id="myTab" role="tablist">
                            <li class="nav-item" role="presentation">
                                <a class="nav-link tab-link neet-bg active" id="neet-tab" data-toggle="tab" href="#neet"
                                    role="tab" aria-controls="neet" aria-selected="true">NEET</a>
                            </li>
                            <li class="nav-item" role="presentation">
                                <a class="nav-link tab-link jee-bg" id="jee-tab" data-toggle="tab" href="#jee"
                                    role="tab" aria-controls="jee" aria-selected="false">JEE Main</a>
                            </li>
                            <li class="nav-item" role="presentation">
                                <a class="nav-link tab-link jee-bg" id="jeemainadvanced-tab" data-toggle="tab"
                                    href="#jeemainadvanced" role="tab" aria-controls="jeemainadvanced"
                                    aria-selected="false">JEE Advanced</a>
                            </li>
                        </ul>
                    </div>

                    <!-- Tab panes -->
                    <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade show active" id="neet" role="tabpanel" aria-labelledby="neet-tab">
                            <div class="row justify-content-center">
                                <ng-container *ngFor ="let neetpackage of neetPackages;let index = index">
                                   <div class="col-lg-3 col-md-6 col-xs-12">
                                    <div class="iliteneet-box">
                                        <div class="ilite-neetbg">
                                        </div>
                                        <h3>{{neetpackage?.name}}</h3>
                                        <h5>Exam Date: {{neetpackage?.date}}</h5>
                                        <div class="examlist">
                                            <div class="tab-flex">
                                                <div class="tab-img">
                                                    <figure>
                                                        <img src="assets/img/tabuser.png" alt="">
                                                    </figure>
                                                </div>
                                                <div class="gradecontent">
                                                    <a href="javascript:void(0);">
                                                        <strong>Current Grade {{neetpackage.grade}}</strong></a>
                                                </div>
                                            </div>
                                            <div class="tab-flex">
                                                <div class="tab-img">
                                                    <figure>
                                                        <img src="assets/img/alarm.png" alt="">
                                                    </figure>
                                                </div>
                                                <div class="gradecontent">
                                                    <a href="javascript:void(0);"><strong>90 mins</strong></a>
                                                </div>
                                            </div>
                                            <div class="tab-flex">
                                                <div class="tab-img">
                                                    <figure>
                                                        <img src="assets/img/content.png" alt="">
                                                    </figure>
                                                </div>
                                                <div class="gradecontent">
                                                    <a href="javascript:void(0);">
                                                        <strong class="d-flex flex-nowrap">
                                                            {{neetpackage?.subjectsDisplayName}}
                                                        </strong></a>
                                                </div>
                                            </div>
                                            <div class="tab-flex">
                                                <div class="tab-img">
                                                    <figure>
                                                        <img src="assets/img/edit.png" alt="">
                                                    </figure>
                                                </div>
                                                <div class="gradecontent">
                                                    <a href="javascript:void(0);"><strong>Total of 90
                                                            questions</strong></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ilte-btncenter">
                                            <div (click)="registerNowTab(neetpackage)">
                                                <a><button type="button" class="ilite-regbtn">REGISTER
                                                        NOW</button></a>
                                            </div>
                                            <div>
                                                <a><button type="button" class="ilite-syllabusbtn"
                                                         (click)="viewSyllabus(neetpackage)">SYLLABUS</button></a>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                </ng-container>
                                
                               
                            </div>
                        </div>
                        <div class="tab-pane fade" id="jee" role="tabpanel" aria-labelledby="jee-tab">
                            <div class="row justify-content-center">
                                <ng-container *ngFor ="let jeepackage of jeePackages;let index = index"> 
                                    <div class="col-lg-3 col-md-6 col-xs-12">
                                        <div class="ilitejee-box">
                                            <div class="ilite-jeebg">
                                            </div>
                                            <h3>{{jeepackage?.name}}</h3>
                                            <h5>Exam Date: {{jeepackage?.date}}</h5>

                                            <div class="examlist">
                                                <div class="tab-flex">
                                                    <div class="tab-img">
                                                        <figure>
                                                            <img src="assets/img/tabuser.png" alt="">
                                                        </figure>
                                                    </div>
                                                    <div class="gradecontent">
                                                        <a href="javascript:void(0);"><strong>Current Grade {{jeepackage?.grade}}</strong></a>
                                                    </div>
                                                </div>
                                                <div class="tab-flex">
                                                    <div class="tab-img">
                                                        <figure>
                                                            <img src="assets/img/alarm.png" alt="">
                                                        </figure>
                                                    </div>
                                                    <div class="gradecontent">
                                                        <a href="javascript:void(0);"><strong>90 mins</strong></a>
                                                    </div>
                                                </div>
                                                <div class="tab-flex">
                                                    <div class="tab-img">
                                                        <figure>
                                                            <img src="assets/img/content.png" alt="">
                                                        </figure>
                                                    </div>
                                                    <div class="gradecontent">
                                                        <a href="javascript:void(0);">
                                                            <strong class="d-flex flex-nowrap"> 
                                                                {{jeepackage?.subjectsDisplayName}}
                                                            </strong></a>
                                                    </div>
                                                </div>
                                                <div class="tab-flex">
                                                    <div class="tab-img">
                                                        <figure>
                                                            <img src="assets/img/edit.png" alt="">
                                                        </figure>
                                                    </div>
                                                    <div class="gradecontent">
                                                        <a href="javascript:void(0);"><strong>Total of 90
                                                                questions</strong></a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="ilte-btncenter">
                                                <div>
                                                    <a  ><button type="button"  (click)="registerNowTab(jeepackage)" class="ilite-jeeregbtn">REGISTER
                                                            NOW</button></a>
                                                </div>
                                                <div>
                                                    <a><button type="button" class="ilite-jeesyllabusbtn"
                                                             (click)="viewSyllabus(jeepackage)">SYLLABUS</button></a>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                               </ng-container>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="jeemainadvanced" role="tabpanel"
                            aria-labelledby="jeemainadvanced-tab">
                            <div class="row justify-content-center">
                                <ng-container *ngFor ="let jeeadvancedpackage of jeeAdvancedPackages;let index = index"> 
                                <div class="col-lg-3 col-md-6 col-xs-12">
                                    <div class="ilitejee-box">
                                        <div class="ilite-jeebg">
                                        </div>
                                        <h3>{{jeeadvancedpackage?.name}}</h3>
                                        <h5>Exam Date: {{jeeadvancedpackage?.date}}</h5>

                                        <div class="examlist">
                                            <div class="tab-flex">
                                                <div class="tab-img">
                                                    <figure>
                                                        <img src="assets/img/tabuser.png" alt="">
                                                    </figure>
                                                </div>
                                                <div class="gradecontent">
                                                    <a href="javascript:void(0);"><strong>Current Grade {{jeeadvancedpackage?.grade}}</strong></a>
                                                </div>
                                            </div>
                                            <div class="tab-flex">
                                                <div class="tab-img">
                                                    <figure>
                                                        <img src="assets/img/alarm.png" alt="">
                                                    </figure>
                                                </div>
                                                <div class="gradecontent">
                                                    <a href="javascript:void(0);"><strong>90 mins</strong></a>
                                                </div>
                                            </div>
                                            <div class="tab-flex">
                                                <div class="tab-img">
                                                    <figure>
                                                        <img src="assets/img/content.png" alt="">
                                                    </figure>
                                                </div>
                                                <div class="gradecontent">
                                                    <a href="javascript:void(0);"><strong class="d-flex flex-nowrap">
                                                        {{jeeadvancedpackage?.subjectsDisplayName}}
                                                        </strong></a>
                                                </div>
                                            </div>
                                            <div class="tab-flex">
                                                <div class="tab-img">
                                                    <figure>
                                                        <img src="assets/img/edit.png" alt="">
                                                    </figure>
                                                </div>
                                                <div class="gradecontent">
                                                    <a href="javascript:void(0);"><strong>Total of 90
                                                            questions</strong></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ilte-btncenter">
                                            <div>
                                                <a><button (click)="registerNowTab(jeeadvancedpackage)" type="button" class="ilite-jeeregbtn">REGISTER
                                                        NOW</button></a>
                                            </div>
                                            <div>
                                                <a><button type="button" class="ilite-jeesyllabusbtn"
                                                        (click)="viewSyllabus(jeeadvancedpackage)">SYLLABUS</button></a>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>



</section>

<!-- top rankers starts -->
<section class="ilite-toprankers">
    <div class="container customcontainer">
        <div class="ilite-topranker-bg">
            <div class="row">
                <div class="col-lg-4 col-xs-12 ilite-prize">
                    <div>
                        <h3>Exciting Prizes for <br> <span class="ilite-top">top rankers*</span></h3>
                    </div>

                </div>
                <div class="col-lg-8 col-xs-12">
                    <div class="ilite-rankers-sec">
                        <div class="row">
                            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                <div class="ilitetop-center">
                                    <figure>
                                        <img src="assets/img/T20.png" alt="">
                                    </figure>
                                    <h4>Chance to Watch</h4>
                                    <p>a match in UAE</p>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                <div class="ilitetop-center">
                                    <figure>
                                        <img src="assets/img/nasa.png" alt="">
                                    </figure>
                                    <h4>Nasa</h4>
                                    <p>Trip</p>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                <div class="ilitetop-center">
                                    <figure>
                                        <img src="assets/img/bike.png" alt="">
                                    </figure>
                                    <h4>Chance to win</h4> 
                                    <p>Sports Bike</p>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                <div class="ilitetop-center">
                                    <figure>
                                        <img src="assets/img/smartlaptop.png" alt="">
                                    </figure>
                                    <h4>Laptops </h4>
                                    <p>and Smartwatches</p>
                                </div>
                            </div>
                            
                            
                        </div>

                    </div>

                </div>
            </div>
        </div>
        <div class="ilite-terms">
            <a data-toggle="modal" data-target=".bd-example-modal-lg">&#42; Terms & Conditions</a>
        </div>
        <!-- </div> -->
    </div>

    <!-- terms model -->
    <div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content termscontent">
                <div class="popup">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true"
                            class="bg-close">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="termshead">
                        <h3>Terms & Conditions</h3>
                        <p>ILITE (Infinity Learn India Talent Exam) <br>
                            (Paid Scholarship Test)
                        </p>
                    </div>
                    <div>
                        <p>1. The ILITE (Infinity Learn India Talent Exam) is a paid scholarship Test organized by Rankguru Technology Solutions
                            Private Limited (“Infinity Learn”). The Test shall be valid only within the territory of India.</p>
                        <p>2. ILITE shall be governed by the following Terms and Conditions as well as the Terms and Conditions of the platform,
                            the online Privacy Policies and Community Guidelines available on the Infinity Learn website.
                            <a href="https://infinitylearn.com/">www.infinitylearn.com</a>
                        </p>
                        <p>3. Those participating in ILITE shall be hereinafter referred to as the “Participant/s.</p>
                        <p>4. The Participant/s shall be eligible to win Prizes and scholarships (“Prizes”) provided on the Infinity Learn
                            website, and such Prizes shall be subject to the Terms and Conditions given herein. The details of the Prizes shall
                            be as given on the Infinity Learn website or as communicated over email or any other mode of communication. </p>
                        <p>5. In order to become a Participant in ILITE, the Participant must conform to the following eligibility criteria in
                            addition to the Test specific eligibility criteria listed in these terms and conditions:
                        </p>
                        <ul>
                            <li>(i) an Individual;</li>
                            <li>(ii) an Indian citizen;</li>
                            <li>(iii) residing in India</li>
                            <li>(iv) legally eligible to enter into a contract;</li>
                            <li>(v) must be a registered user of the Infinity Learn platform.</li>
                        </ul>
                        <p>6. Information that is available on the official ILITE web page shall be the only authentic and valid information
                            with respect to the Test. Infinity Learn shall not be responsible for any incorrect/misleading information relating
                            to ILITE, presented/displayed on any other source other than the ILITE page on Infinity Learn website & shall not be
                            liable for any loss suffered by any Participants based on the representation, Terms and Conditions, the information
                            presented/displayed on any other source other than the ILITE page.</p>
                        <p>7. To participate in ILITE, the Participants are required to follow the following steps:</p>
                        <ul>
                            <li>Log into your Infinity Learn account.</li>
                            <li>(i) Participate in the Test while it is live and active on the ILITE site;</li>
                            <li>(ii) Participants ought to attempt the Test live to remain eligible for all the Prizes.
                            </li>
                        </ul>
                        <p>8.Responses to the ILITE questions should be submitted by the Participants while the Test is live and available on
                            the ILITE web page on Infinity Learn site. Participants can begin the Test once it is live, but the Test will end at
                            the stipulated end time automatically.</p>
                        <p>9. ILITE shall be conducted on 10th October, 2021 or on any other dates that may be communicated by Infinity Learn.
                        </p>
                        <p>10. A Participant who has received a Prize for one Test shall not be eligible for the Prize in the other Tests
                            irrespective of their ILITE ranking.
                        </p>
                        <p>11. After the results are announced, Infinity Learn will conduct a thorough evaluation to determine if the
                            Participants have conducted themselves in accordance with the ILITE Terms and Conditions.</p>
                        <p>12. If at any point in time it is brought to the attention or knowledge of Infinity Learn that the Participant have
                            engaged in any unethical practices including but not limited to having prior access to the questions in the Test,
                            usage of any circumventing technology to
                            manipulate the product algorithm or any act which will give the Participant an unfair advantage over other
                            Participants, Infinity Learn may at its sole discretion cancel any Prize, Scholarship or reward due to the
                            Participant and bar the Participant for using any product or services offered by Infinity Learn.
                        </p>
                        <p>13. All Prizes, Scholarships,and rewards are subject to the Participants adhering to the ILITE Terms and Conditions
                            and the Terms and Conditions of the Infinity Learn website.
                        </p>
                        <p>14. The product algorithm evaluates the Participants based on the speed and accuracy of the answers to be displayed
                            on the leaderboard.</p>
                        <p>15. Infinity Learn has endeavored to make all reasonably practicable arrangements to minimize communication system
                            difficulties or any other technical issues but can make no guarantee thereof and shall not be liable for any
                            failures in the same. Infinity Learn shall not be responsible and/or liable in any manner whatsoever in case the
                            Participant is unable to participate due to any technical issues or due to the issues with their internet provider,
                            hardware, facility provider, etc.</p>
                        <p>16. Any Participant found participating in the Test through multiple accounts shall be disqualified immediately and
                            shall not be entitled to any Prizes. The Participant shall be barred from participating in any future contests,
                            tests or ILITE itself at the sole discretion of Infinity Learn.</p>
                        <p>17. ILITE is open to participation by individuals only. Corporate entities, agencies and any non-human legal entities
                            are barred from participating in ILITE. Employees, consultants, interns and educators Infinity Learn employees and
                            educators are not allowed to participate in ILITE.</p>
                        <p>18. There is an entry fee or participation fee payable by the Participant/s of Rs. 249/- to Infinity Learn to be able
                            to participate in the Test. Any Participant taking part in ILITE and is declared the Top Ranker of the ILITE by
                            Infinity Learn and is unable to fulfill any one or more eligibility requirements, as specified in the abovementioned
                            clauses of these Terms and Conditions, on the last date of the Test, shall be disqualified from receiving any
                            Infinity Learn Prizes, Scholarships under this Test. Any communication, clarification, query, dispute in this regard
                            by the Top Ranker, or any of the legal heirs/guardians of the Top Ranker in any manner shall not be entertained by
                            Infinity Learn.</p>
                        <p>19. Collection of Prize shall be subject to: </p>
                        <ul>
                            <li>(i) Upon successful completion of the process i.e., responds within 10 days of
                                communication from Infinity Learn team</li>
                            <li>(ii) Verification of ID</li>
                            <li>(iii) Provision of correct details (address, phone number)</li>
                            <li>(iv) Prizes shall be dispatched or communicated in 2-3 weeks and shall be delivered
                                within 90 days after
                                successful completion of verification.</li>
                            <li>(v) Further it is clarified that participation in the ILITE will not in itself make the
                                Participant eligible for the Prize</li>
                            <li>(vi) When you take the admission into courses for JEE & NEET as per the criteria mentioned by the Infinity
                                Learn.</li>
                        </ul>
                        <p>20. The Prize/s shall be subject to the laws of India, including all the applicable tax laws.
                        </p>
                        <p>21. Infinity Learn will not be responsible, in case anyone is unable to participate in the Test on account of not
                            having access to ILITE.</p>
                        
                        <p>22. Participant/s winning the Prize/s shall be contacted by Infinity Learn via email or any other mode of
                            communication. Infinity Learn shall not be liable for any loss, claim, damage, expenses whether expressed, implied,
                            real, consequential incurred by the Participant due
                            to participation, non-participation or otherwise in the ILITE. Infinity Learn shall not be liable for any loss that
                            occurs during the dispatch of the Prize to the Top Ranker's address. Once the Prize is accepted by the Top Ranker,
                            Infinity Learn shall not be responsible for paying any applicable taxes, fee, charges, etc. related to the Prize.
                        </p>
                        <p>23. Infinity Learn shall not be responsible for any deficiency in the Prizes and does not make a representation about
                            the quality, performance, features, endurance, finishing, benefits, or fitness of the Prizes.</p>
                        <p>24. The Top Rankers shall be contacted by the Infinity Learn team within 14 days upon the conclusion of ILITE. In the
                            event there is no response/acknowledgement from the Top Ranker to the communication from Infinity Learn within a
                            period of 7 days, then the Prize shall be deemed to be forfeited.</p>
                        <p>25. The Top Rankers shall submit the necessary documentation/proof of identity and other relevant documentation as
                            requested by Infinity Learn, within 7 days of receiving intimation from Infinity Learn.</p>
                        <p>26. The Prizes are non-endorsable, not transferable, and non-substitutable. The Prizes are offered on a 'NO
                            EXCHANGE-NO REFUND' basis. Infinity Learn will not entertain any requests for exchange in lieu of the Prize(s).</p>
                        <p>27. Each Top Ranker shall provide the following documentation to enable to Infinity Learn to give the Prize to the
                            Top Ranker:</p>
                        <ul>
                            <li>(i) Name</li>
                            <li>(ii) Complete postal address with pin code with proof of address</li>
                            <li>(iii) Photograph</li>
                            <li>(iv) Proof of identity</li>
                            <li>(v) Proof of Admission to Infinity Learn Course</li>
                            <li>(vi) Previous year mark sheets and other criteria as required</li>
                        </ul>
                        <p>28. Infinity Learn reserves the right to modify, add or delete any of the terms and conditions at any point of time
                            at its sole discretion without serving any prior intimation.</p>
                        <p>29. Any disputes with respect to ILITE shall subject to be governed by and construed in accordance with the laws of
                            India, without reference to principles of conflict of laws and the courts in Hyderabad shall have the exclusive
                            jurisdiction to determine any disputes arising out of, under, or in relation to, this ILITE.</p>
                        
                        <p>30. Top Ranker shall assign the right to use their name, image, or visual representation, comment, or statement, in
                            any media for promotional, marketing, and advertising purposes or any other objective by Infinity Learn, as deemed
                            appropriate by Infinity Learn.</p>
                        <p>31. The Participant shall indemnify and hold harmless Infinity Learn, its officers, employees, agents, licensees, etc
                            against any and all damages, claims, losses, demands, actions, causes of action, suits, litigation, costs and
                            expenses (including but not limited to, the publication of response(s) submitted by the Participant as a part of, or
                            in association with the ILITE without limitation, reasonable attorneys' and consultants' fees).</p>
                        <p>32. Infinity Learn shall not be liable for any failure to comply with its obligations caused by weather conditions,
                            fire, flood, strike, hurricane, industrial dispute, war, hostilities, terrorist attack, political unrest, riots,
                            civil commotion, inevitable accidents, pandemic and/or epidemic, acts of God or any other circumstances amounting to
                            Force Majeure.</p>
                        <p>33. Infinity Learn shall not be responsible for any loss or damage. If Infinity Learn is required to discontinue or
                            cancel the ILITE in compliance with any law, ruling, order, regulation, requirement, or instruction of any
                            Central/State Government or for any other unavoidable
                            reason beyond its control. The Participants shall be informed of such discontinuance/cancellation as early as
                            possible.
                        </p>
                        <p>34. The aggregate liability of Infinity Learn in case of any damage, loss, cost, claim, liability, or expense
                            (including legal costs and expenses) caused to or incurred by any act, omission, or representation in respect of the
                            Prize of ILITE to any Top Ranker, shall not exceed the value of Prize INR 50. Further, Infinity Learn shall not be
                            liable to share the invoice of the Prize unit with the Top Ranker at any given point of time whatsoever.</p>
                        <p>35. For more details regarding the Test syllabus, date, and time of the ILITE, please visit our website,
                            (infinitylearn.com/ilite).</p>
                        <p>36. Any ranks/marks granted before the official announcement of the results shall be provisional and cannot be used
                            to claim any rewards, certificates, etc. by Infinity Learn.</p>
                        
                        <p>37. Participants shall be eligible to avail Prizes for a maximum of 1 Main ILITE Test,
                            subject to meeting the
                            eligibility criteria and post the Test verification of the Test. Infinity Learn has the sole
                            discretion with respect
                            to the distribution of the Prizes and shall decide the eligibility of a Participant to
                            receive the Prize if it has a
                            reason to believe the Participant has engaged in unfair practices or has mala fide
                            intentions.
                        </p>
                        <p>38. Additionally, the following criteria shall be applicable to participate in the Test: </p>
                        
                        <ul>
                            <li>(i) For Class XI JEE Aspirants: Students studying in Class 11th as on 1st Jan 2021</li>
                            <li>(ii) For Class XII JEE Aspirants: Students studying in Class 12th as on 1st Jan 2021</li>
                            <li>(iii) For Class XIII JEE Aspirants: Students completed Class 12th as on 1st Jan 2021</li>
                            <li>(iv) For Class XI NEET Aspirants: Students studying in Class 11th as on 1st Jan 2021</li>
                            <li>(v) For Class XII NEET Aspirants: Students studying in Class 12th as on 1st Jan 2021</li>
                            <li>(vi) For Class XIII NEET Aspirants: Students completed Class 12th as on 1st Jan 2021</li>
                            <li>(vii) For Class X Students: Students studying in Class 10th as on 1st Jan 2021</li>
                        </ul>
                        <p>39. Ranking Criteria: Participants securing the highest marks in the least possible Test time
                            shall be used as the
                            criteria to determine the ranks. In the event where two or more Participants secure the same
                            mark, the time taken to
                            complete the Test shall be used as a tiebreaker and the Participants with lesser time taken
                            to complete the Test
                            shall be ranked higher.</p>
                        <p>40. Results along with the final ranks shall be declared with in 10 days after the test.</p>
                        <p>41. Documents to be submitted to claim rewards: Birth certificate/Aadhar card to certify age as on 1st Jan 2021. /
                            Previous year mark sheet/ Interaction with faculties for top rankers and anything else as required.</p>
                        <p>42. Ultimate/Advanced package subscribers can also participate in all the tests, but they
                            will remain eligible only
                            for the rewards and prizes, and not the Infinity Learn Scholarships.
                        </p>
                        <p>43. Top rankers will have an interaction with Infinity Learn faculties to avail the
                            scholarship / prize.</p>
                        <p>44. Students have to share their current and previous year marksheet to avail scholarship /
                            prize.</p>
                        <p>45. To avail the prize as per the ranks a student should take an admission as per the selected course in Infinity
                            Learn.</p>
                        <p>46. Scholarship Criteria: </p>
                        
                            <ul>
                                <li>(i) Upto 100% for top 10 students</li>
                                <li>(ii) Upto 90% for top 100 students</li>
                                <li>(iii) Upto 80% for top 200 students</li>
                                <li>(iv) Upto 70% for top 500 students</li>
                                <li>(v) Upto 60% for top 1000 students</li>
                                <li>(vi) Upto 50% for top 2000 students</li>
                                <li>(vii) Upto 40% for top 5000 students</li>
                                <li>(viii) Upto 30% for top 10000 students</li>
                                <li>(ix) Upto 20% for top 25000 students</li>
                                <li>(x) Upto 10% for below 25000 students</li>
                            </ul>    
                        <p>47. Cricket Match and Educational Trip prizes are applicable for students who score 99 percent marks and above, of the total marks of the exam. </p>
                        <p>48. Prizes will be awarded to those students who scored the highest across six ILITE tests.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

</section>

     <!-- our toppers -->
     <section class="ilite-ourtopperssec">
        <div class="container customcontainer">
            <div class="ourtoppers-head">
                <h1 class="repeatertopperhead">Our Toppers</h1>
                <p class="toppersubhead"><span class="ilite-progress">No Progress?</span>  We Provide A <span class="ilite-smarter">Smarter</span> Way To Student, Find Thousands Like You Who Succeeded With Us!</p>
            </div>
            <div class="row">
                <div class="col-lg-12 col-md-12 col-xs-12">
                    <div class="tab" role="tabpanel">
                        <div class="quotes-center">
                            <!-- Nav tabs -->
                            <ul class="nav nav-tabs justify-content-center" id="myTab2" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <a class="nav-link tab-link neet-bg active" id="topperneet-tab" data-toggle="tab" href="#topperneet" role="tab" aria-controls="topperneet" aria-selected="true">NEET</a>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <a class="nav-link tab-link jee-bg" id="topperjee-tab" data-toggle="tab" href="#topperjee" role="tab" aria-controls="topperjee" aria-selected="false">JEE</a>
                                </li>
                            </ul>
                        </div>

                        <!-- Tab panes -->
                        <div class="tab-content" id="myTabContent2">
                            <div  class="tab-pane fade show active" id="topperneet" role="tabpanel" aria-labelledby="topperneet-tab">
                                <div class="row">
                                    <div class="col-lg-4 col-md-4 col-xs-12">
                                        <div class="ilitetopneet-box">
                                             <figure>
                                                 <img src="assets/img/top1.png" alt="">
                                             </figure>
                                             <div class="ilite-topcontent">
                                                 <h5 class="neetcontentname">Soyeb  Aftab</h5>
                                                 <div>
                                                     <p class="neetcontentrank">AIR 1 <br> NEET 2020</p>
                                                 </div>
                                             </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-xs-12">
                                        <div class="ilitetopneet-box">
                                            <figure>
                                                <img src="assets/img/top2.png" alt="">
                                            </figure>
                                            <div class="ilite-topcontent">
                                                <h5 class="neetcontentname">Snikita Thummala</h5>
                                                <div>
                                                    <p class="neetcontentrank">AIR 3 <br> NEET 2020</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-xs-12">
                                        <div class="ilitetopneet-box">
                                            <figure>
                                                <img src="assets/img/top3.png" alt="">
                                            </figure>
                                            <div class="ilite-topcontent">
                                                <h5 class="neetcontentname">Chaitanya Sindhu</h5>
                                                <div>
                                                    <p class="neetcontentrank">AIR 6 <br> NEET 2020</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="topperjee" role="tabpanel" aria-labelledby="topperjee-tab">
                               <div class="row">
                                    <div class="col-lg-4 col-md-4 col-xs-12">
                                        <div class="ilitetopjee-box">
                                            <figure>
                                                <img src="assets/img/top4.png" alt="">
                                            </figure>
                                            <div class="ilite-jeetopcontent">
                                                <h5 class="jeecontentname">Landa Jitendra</h5>
                                                <div>
                                                    <p class="jeecontentrank">AIR 4 <br> JEE Main 2020</p>
                                                </div>
                                            </div>
                                       </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-xs-12">
                                        <div class="ilitetopjee-box">
                                            <figure>
                                                <img src="assets/img/top5.png" alt="">
                                            </figure>
                                            <div class="ilite-jeetopcontent">
                                                <h5 class="jeecontentname">G. Bhuvan Reddy</h5>
                                                <div>
                                                    <p class="jeecontentrank">AIR 2 <br>JEE Advanced 2020</p>
                                                </div>
                                            </div>
                                       </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-xs-12">
                                        <div class="ilitetopjee-box">
                                            <figure>
                                                <img src="assets/img/top6.png" alt="">
                                            </figure>
                                            <div class="ilite-jeetopcontent">
                                                <h5 class="jeecontentname">Dhvanit Beniwal</h5>
                                                <div>
                                                    <p class="jeecontentrank">AIR 10 <br>JEE Advanced 2020</p>
                                                </div>
                                            </div>
                                       </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Top faculty -->
    <section class="ilite-topfaculty-sec">
        <div class="container customcontainer">
            <div class="ilite-faculty-bg">
                <div class="ilite-topfaculty-head">
                    <h1 class="repeaterfachead">Our <span class="top">Top</span> Faculties</h1>
                    <p class="facsubhead">Access to India's Best Educators is Just a Subscription Away</p>
                </div>
                <div class="IL_ilite_fac-slide-box">
                    <div class="nav-btn facultyprev-slide flex-grow-0 flex-shrink-0 cursor-pointer" (click)="prevFac()"></div>
                    <div id="IL_ilite-fs-parent">
                        <div id="faculty-slider" class="owl-carousel">
                        
                            <div class="item">
                                <div class="ilite-faculty-flex">
                                    <div class="ilite-faculty-img">
                                        <img src="assets/img/supreetilite.png" class="facultyimg" alt="">
                                    </div>
                                    <div class="ilite-faculty-content">
                                        <h4 class="facname">Supreet Singh</h4>
                                        <p class="faccontent">9+ years of teaching experience in Physics for JEE & NEET. Mentored more than 5000 students.
                                        </p>
                                        <h6 class="facrating">4.8+ Rating</h6>
                                        <ul class="ilitetop-rating">
                                            <li><i class="star on"></i></li>
                                            <li><i class="star on"></i></li>
                                            <li><i class="star on"></i></li>
                                            <li><i class="star on"></i></li>
                                            <li><i class="star on"></i></li>
                                            <li><a href="#"><strong>7.8k Reviews</strong></a></li>
                                        </ul>
                                        <ul class="ilite-teaches">
                                            <li>Teaches:</li>
                                            <li><a href="#" class="ilite-subject-bg">Physics</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="item">
                                <div class="ilite-faculty-flex">
                                    <div class="ilite-faculty-img">
                                        <img src="assets/img/vibhatilite.png" class="facultyimg" alt="">
                                    </div>
                                    <div class="ilite-faculty-content">
                                        <h4 class="facname">Vibhati Jain</h4>
                                        <p class="faccontent">5+ years of teaching experience in Physics for NEET and mentored 10000+ students. Her students have secured 99%ile and 100%ile.</p>
                                        <h6 class="facrating">4.7+ Rating</h6>
                                        <ul class="ilitetop-rating">
                                            <li><i class="star on"></i></li>
                                            <li><i class="star on"></i></li>
                                            <li><i class="star on"></i></li>
                                            <li><i class="star on"></i></li>
                                            <li><i class="star half"></i></li>
                                            <li><a href="#"><strong>9.7k Reviews</strong></a></li>
                                        </ul>
                                        <ul class="ilite-teaches">
                                            <li>Teaches:</li>
                                            <li><a href="#" class="ilite-subject-bg">Physics</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="item">
                                <div class="ilite-faculty-flex">
                                    <div class="ilite-faculty-img">
                                        <img src="assets/img/prakharilite.png" class="facultyimg" alt="">
                                    </div>
                                    <div class="ilite-faculty-content">
                                        <h4 class="facname">Prakhar Verma</h4>
                                        <p class="faccontent">Completed dual degree in BTech & MTech from IIT (Kharagpur) in Chemical Engineering. Has 8+ years' experience in
                                            teaching Physics for JEE. Produced many AIRs</p>
                                        <h6 class="facrating">4.5+ Rating</h6>
                                        <ul class="ilitetop-rating no-mar">
                                            <li><i class="star on"></i></li>
                                            <li><i class="star on"></i></li>
                                            <li><i class="star on"></i></li>
                                            <li><i class="star on"></i></li>
                                            <li><i class="star half"></i></li>
                                            <li><a href="#"><strong>12k Reviews</strong></a></li>
                                        </ul>
                                        <ul class="ilite-teaches">
                                            <li>Teaches:</li>
                                            <li><a href="#" class="ilite-subject-bg">Physics</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="item">
                                <div class="ilite-faculty-flex">
                                    <div class="ilite-faculty-img">
                                        <img src="assets/img/aman.jpg" class="facultyimg" alt="">
                                    </div>
                                    <div class="ilite-faculty-content">
                                        <h4 class="facname">Aman Kumar</h4>
                                        <p class="faccontent">B.E Chemical Engineer. 8+ years of experience in teaching Chemistry for NEET.</p>
                                        <h6 class="facrating">4.6+ Rating</h6>
                                        <ul class="ilitetop-rating">
                                            <li><i class="star on"></i></li>
                                            <li><i class="star on"></i></li>
                                            <li><i class="star on"></i></li>
                                            <li><i class="star on"></i></li>
                                            <li><i class="star half"></i></li>
                                            <li><a href="#"><strong>10k Reviews</strong></a></li>
                                        </ul>
                                        <ul class="ilite-teaches">
                                            <li>Teaches:</li>
                                            <li><a href="#" class="ilite-subject-bg">Chemistry</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="item">
                                <div class="ilite-faculty-flex">
                                    <div class="ilite-faculty-img">
                                        <img src="assets/img/sarfaraz.jpg" class="facultyimg" alt="">
                                    </div>
                                    <div class="ilite-faculty-content">
                                        <h4 class="facname">Shaik Sarfaraz</h4>
                                        <p class="faccontent">15+ years' experience in teaching Chemistry students for JEE/NEET and produced Many AIRs.</p>
                                        <h6 class="facrating">4.6+ Rating</h6>
                                        <ul class="ilitetop-rating">
                                            <li><i class="star on"></i></li>
                                            <li><i class="star on"></i></li>
                                            <li><i class="star on"></i></li>
                                            <li><i class="star on"></i></li>
                                            <li><i class="star half"></i></li>
                                            <li><a href="#"><strong>9k Reviews</strong></a></li>
                                        </ul>
                                        <ul class="ilite-teaches">
                                            <li>Teaches:</li>
                                            <li><a href="#" class="ilite-subject-bg">Chemistry</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="item">
                                <div class="ilite-faculty-flex">
                                    <div class="ilite-faculty-img">
                                        <img src="assets/img/suchita.jpg" class="facultyimg" alt="">
                                    </div>
                                    <div class="ilite-faculty-content">
                                        <h4 class="facname">Suchita</h4>
                                        <p class="faccontent">Completed MTech from IIT-ISM (Dhanbad). 8+ years' experience in teaching Botany and produced double digit AIRs & many selections into AIIMS, JIPMER, BMC etc.</p>
                                        <h6 class="facrating">4.7+ Rating</h6>
                                        <ul class="ilitetop-rating">
                                            <li><i class="star on"></i></li>
                                            <li><i class="star on"></i></li>
                                            <li><i class="star on"></i></li>
                                            <li><i class="star on"></i></li>
                                            <li><i class="star half"></i></li>
                                            <li><a href="#"><strong>11k Reviews</strong></a></li>
                                        </ul>
                                        <ul class="ilite-teaches">
                                            <li>Teaches:</li>
                                            <li><a href="#" class="ilite-subject-bg">Botany</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="item">
                                <div class="ilite-faculty-flex">
                                    <div class="ilite-faculty-img">
                                        <img src="assets/img/mythili.jpg" class="facultyimg" alt="">
                                    </div>
                                    <div class="ilite-faculty-content">
                                        <h4 class="facname">Mythili</h4>
                                        <p class="faccontent">15+ years of teaching experience in Zoology. Produced ranks below 10 in KCET. Produced ranks below 10 in EAMCET for 3 consecutive years.</p>
                                        <h6 class="facrating">4.5+ Rating</h6>
                                        <ul class="ilitetop-rating">
                                            <li><i class="star on"></i></li>
                                            <li><i class="star on"></i></li>
                                            <li><i class="star on"></i></li>
                                            <li><i class="star on"></i></li>
                                            <li><i class="star half"></i></li>
                                            <li><a href="#"><strong>8k Reviews</strong></a></li>
                                        </ul>
                                        <ul class="ilite-teaches">
                                            <li>Teaches:</li>
                                            <li><a href="#" class="ilite-subject-bg">Zoology</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="item">
                                <div class="ilite-faculty-flex">
                                    <div class="ilite-faculty-img">
                                        <img src="assets/img/basheer.jpg" class="facultyimg" alt="">
                                    </div>
                                    <div class="ilite-faculty-content">
                                        <h4 class="facname">Basheer Shaik</h4>
                                        <p class="faccontent">15+ years of teaching experience in Mathematics. He has produced many single & double digit ranks such as 5, 18 and many more.</p>
                                        <h6 class="facrating">4.8+ Rating</h6>
                                        <ul class="ilitetop-rating">
                                            <li><i class="star on"></i></li>
                                            <li><i class="star on"></i></li>
                                            <li><i class="star on"></i></li>
                                            <li><i class="star on"></i></li>
                                            <li><i class="star half"></i></li>
                                            <li><a href="#"><strong>13k Reviews</strong></a></li>
                                        </ul>
                                        <ul class="ilite-teaches">
                                            <li>Teaches:</li>
                                            <li><a href="#" class="ilite-subject-bg">Mathematics</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="item">
                                <div class="ilite-faculty-flex">
                                    <div class="ilite-faculty-img">
                                        <img src="assets/img/swagata.jpg" class="facultyimg" alt="">
                                    </div>
                                    <div class="ilite-faculty-content">
                                        <h4 class="facname">Swagata Mukherjee</h4>
                                        <p class="faccontent">6+ years of teaching experience in Zoology and produced double digit AIRs & many selections into AIIMS, AFMC, & IISER.</p>
                                        <h6 class="facrating">4.6+ Rating</h6>
                                        <ul class="ilitetop-rating">
                                            <li><i class="star on"></i></li>
                                            <li><i class="star on"></i></li>
                                            <li><i class="star on"></i></li>
                                            <li><i class="star on"></i></li>
                                            <li><i class="star on"></i></li>
                                            <li><a href="#"><strong>6.9k Reviews</strong></a></li>
                                        </ul>
                                        <ul class="ilite-teaches">
                                            <li>Teaches:</li>
                                            <li><a href="#" class="ilite-subject-bg">Zoology</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="item">
                                <div class="ilite-faculty-flex">
                                    <div class="ilite-faculty-img">
                                        <img src="assets/img/kiran.jpg" class="facultyimg" alt="">
                                    </div>
                                    <div class="ilite-faculty-content">
                                        <h4 class="facname">Kiran Choudhary</h4>
                                        <p class="faccontent">5+ years of teaching experience in Botany. Produced double digit AIRs & many selections into AIIMS.</p>
                                        <h6 class="facrating">4.5+ Rating</h6>
                                        <ul class="ilitetop-rating">
                                            <li><i class="star on"></i></li>
                                            <li><i class="star on"></i></li>
                                            <li><i class="star on"></i></li>
                                            <li><i class="star on"></i></li>
                                            <li><i class="star half"></i></li>
                                            <li><a href="#"><strong>7.9k Reviews</strong></a></li>
                                        </ul>
                                        <ul class="ilite-teaches">
                                            <li>Teaches:</li>
                                            <li><a href="#" class="ilite-subject-bg">Botany</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="nav-btn facultynext-slide flex-grow-0 flex-shrink-0 cursor-pointer" (click)="nextFac()"></div>
                </div>
            </div>
        </div> 
    </section>
     <!-- share with friends -->
     <section class="ilite-sharesec">
        <div class="container customcontainer">
           <div class="iliteshare-bg">
            <div class="row">
                <div class="col-lg-7 col-md-12 col-sm-12 col-xs-12">
                    <div class="ilite-sharecontent">
                        <h4>Share with your <br>friends about <span class="ilite-21">ILITE’21</span></h4>
                        <p>Share this link to help your friends be a part of ILITE’21<br> and get more closer to winning the scholarship*</p>
                        <div class="share-center">
                                <h6>Share Via</h6>
                                <ul class="social-share">
                                    <li><a href="https://wa.me/"><img src="assets/img/whatsapp.png" alt=""></a></li>
                                    <li><a href="https://www.facebook.com/"><img src="assets/img/facebook.png" alt=""></a></li>
                                    <li><a href="https://www.instagram.com/"><img src="assets/img/insta.png" alt=""></a></li>
                                </ul>
                            <div>
                                <div class="input-group copy-group mb-3">
                                    <input type="text" class="ASM_no-box-shadow form-control copy-input" readonly placeholder="https://infinitylearn.com/ilite" 
                                    aria-label="Recipient's username" aria-describedby="basic-addon2">
                                    <div class="input-group-append">
                                        <div class="IL_ilite_tooltip">
                                            <button class="ilite-copy" type="button" (click)="copyFunction()" (mouseout)="outFunc()">
                                              <span class="IL_ilite_tooltiptext" id="myTooltip">Copy text</span>
                                              COPY
                                              </button>
                                            </div>
                                    </div>
                                  </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-5 col-md-12 col-sm-12 col-xs-12">
                    <div class="ilite-shareimg">
                        <figure>
                            <img src="assets/img/shareimg.png" alt="">
                        </figure>
                    </div>
                </div>
            </div>
           </div>
        </div>
    </section>
     <!-- frequently -->
     <section class="ilite-frequently-sec" >
        <div class="container customcontainer">
            <div class="frequent-head">
                <h1>Frequently Asked Questions</h1>
            </div>
            <div class="row">
                <div class="col-lg-12 col-xl-12 col-md-12 col-xs-12">
                    <div class="accordion" id="accordionExample">
                        <div class="card">
                            <div class="card-header cursor-pointer collapsed" data-toggle="collapse" data-target="#collapseOne" id="headingOne">
                                <h2 class="IL_ilite_faq_q mb-0">
                                    <button type="button" class="btn-link collapsed" data-toggle="collapse" data-target="#collapseOne">What
                                        is ILITE ?</button>
                                    <span class="IL_ilite_faq_exp_icon"></span>
                                </h2>
                            </div>
                            <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p>ILITE or Infinity Learn India Talent Exam is a platform for students who want to prepare for
                                        competitive exams like JEE Main, JEE Advanced or NEET and want to avail scholarships for the online courses offered
                                        by Infinity Learn. We help you to take your first step towards your goals.</p>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header cursor-pointer collapsed" data-toggle="collapse" data-target="#collapseTwo" id="headingTwo">
                                <h2 class="IL_ilite_faq_q mb-0">
                                    <button type="button" class=" btn-link collapsed" data-toggle="collapse" data-target="#collapseTwo">Who
                                        can enroll for ILITE ?</button><span class="IL_ilite_faq_exp_icon"></span>
                                </h2>
                            </div>
                            <div id="collapseTwo" class="collapse " aria-labelledby="headingTwo" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p>Students from Class 8th or above studying in schools affiliated with any State, Central, or
                                        International board as well as droppers can enroll for ILITE Scholarship tests.</p>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header cursor-pointer collapsed" data-toggle="collapse" data-target="#collapseThree" id="headingThree">
                                <h2 class="IL_ilite_faq_q mb-0">
                                    <button type="button" class=" btn-link collapsed" data-toggle="collapse" data-target="#collapseThree">Is
                                        there any examination fee for ILITE?</button><span class="IL_ilite_faq_exp_icon"></span>
                                </h2>
                            </div>
                            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p>Yes. The examination fee is Rs 249/-</p>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="card">
                            <div class="card-header" id="headingfour">
                                <h2 class="IL_ilite_faq_q mb-0">
                                    <button type="button" class=" btn-link collapsed" data-toggle="collapse"
                                        data-target="#collapsefour">What are the terms and conditions of ILITE ?</button><i
                                        class="fa fa-plus"></i>
                                </h2>
                            </div>
                            <div id="collapsefour" class="collapse" aria-labelledby="headingfour" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p>For detailed terms and conditions <a href="javascript:void(0);">Click HERE</a></p>
                                </div>
                            </div>
                        </div> -->
                        <div class="card">
                            <div class="card-header cursor-pointer collapsed" data-toggle="collapse" data-target="#collapsefive" id="headingfive">
                                <h2 class="IL_ilite_faq_q mb-0">
                                    <button type="button" class=" btn-link collapsed" data-toggle="collapse"
                                        data-target="#collapsefive">What are the prizes and scholarships for ILITE?</button><span class="IL_ilite_faq_exp_icon"></span>
                                </h2>
                            </div>
                            <div id="collapsefive" class="collapse" aria-labelledby="headingfive" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p>Students can win upto 100% scholarship apart from other exciting prizes like Fully paid trip to watch
                                        a world cup match in UAE, Sports bike, NASA educational trip, Laptops, Ipads, Iphones, Smart
                                        Watches, Alexa, and an Internship Opportunity with Infinity Learn.</p>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header cursor-pointer collapsed" data-toggle="collapse" data-target="#collapsesix" id="headingsix">
                                <h2 class="IL_ilite_faq_q mb-0">
                                    <button type="button" class=" btn-link collapsed" data-toggle="collapse" data-target="#collapsesix">Who
                                        is eligible for Scholarship ?</button><span class="IL_ilite_faq_exp_icon"></span>
                                </h2>
                            </div>
                            <div id="collapsesix" class="collapse" aria-labelledby="headingsix" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p>The students who are studying in Grade 8,9,10, 11, 12 and 13 and want to take admission into NEET &
                                        JEE Main, JEE Advanced courses offered by Infinity Learn are eligible for the scholarships.</p>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header cursor-pointer collapsed" data-toggle="collapse" data-target="#collapseseven" id="headingseven">
                                <h2 class="IL_ilite_faq_q mb-0">
                                    <button type="button" class=" btn-link collapsed" data-toggle="collapse"
                                        data-target="#collapseseven">Where can I attempt the test?</button><span class="IL_ilite_faq_exp_icon"></span>
                                </h2>
                            </div>
                            <div id="collapseseven" class="collapse" aria-labelledby="headingseven" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p>You can attempt the test on your desktop or mobile by signing in to the Infinity Learn website using
                                        your registered mobile number. Please ensure that you have a good internet connection.</p>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header cursor-pointer collapsed" data-toggle="collapse" data-target="#collapseeight" id="headingeight">
                                <h2 class="IL_ilite_faq_q mb-0">
                                    <button type="button" class=" btn-link collapsed" data-toggle="collapse" data-target="#collapseeight">Is
                                        there a physical centre for ILITE?</button><span class="IL_ilite_faq_exp_icon"></span>
                                </h2>
                            </div>
                            <div id="collapseeight" class="collapse" aria-labelledby="headingeight" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p>No. The exam is completely online. You will be able to take the exam from anywhere in India by
                                        signing in to Infinity Learn website through your desktop or mobile.</p>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header cursor-pointer collapsed" data-toggle="collapse" data-target="#collapsenine" id="headingnine">
                                <h2 class="IL_ilite_faq_q mb-0">
                                    <button type="button" class=" btn-link collapsed" data-toggle="collapse"
                                        data-target="#collapsenine">What happens if I am late to the test?</button><span class="IL_ilite_faq_exp_icon"></span>
                                </h2>
                            </div>
                            <div id="collapsenine" class="collapse" aria-labelledby="headingnine" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p>We encourage you to begin the test on time. However, if you are not able to begin on time, you will
                                        need to finish the test within the allotted time left.</p>
                                </div>
                            </div>
                        </div>
                    
                        <div class="card">
                            <div class="card-header cursor-pointer collapsed" data-toggle="collapse" data-target="#collapse11" id="heading11">
                                <h2 class="IL_ilite_faq_q mb-0">
                                    <button type="button" class=" btn-link collapsed" data-toggle="collapse" data-target="#collapse11">What
                                        will be the marking scheme for ILITE? Will there be any negative marking?</button><span class="IL_ilite_faq_exp_icon"></span>
                                </h2>
                            </div>
                            <div id="collapse11" class="collapse" aria-labelledby="heading11" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p>For Grade 12 and 13 (NEET & JEE Main, JEE Advanced), Each correct answer will be awarded with 4 marks and
                                        the wrong answer will be penalyzed with 1 mark. For Grade 11 (NEET & JEE Main, JEE Advanced, Each correct
                                        answer will be awarded with 4 marks. No negative marking. <br>
                                        For Grade 9 & 10 ( Foundation Courses , Each correct
                                        answer will be awarded with 4 marks.)
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header cursor-pointer collapsed" data-toggle="collapse" data-target="#collapse12" id="heading12">
                                <h2 class="IL_ilite_faq_q mb-0">
                                    <button type="button" class=" btn-link collapsed" data-toggle="collapse" data-target="#collapse12">What
                                        will be the syllabus for ILITE?</button><span class="IL_ilite_faq_exp_icon"></span>
                                </h2>
                            </div>
                            <div id="collapse12" class="collapse" aria-labelledby="heading12" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p>For Grade 9 ( Foundation Courses ) the syllabus will be Grade 8 Mathematics & Science.
                                        <br><br>
                                        For Grade 10 ( Foundation Courses ) the syllabus will be Grade 9 Mathematics & Science.
                                        <br><br>
                                        For Grade 10 (NEET & JEE Main, JEE Advanced) the syllabus will be Grade 9 Mathematics & Science.
                                        <br><br>
                                        For Grade 11 (NEET & JEE Main, JEE Advanced)
                                        the syllabus will be Grade 10 Mathematics & Science.
                                        <br><br>
                                        For Grade 12 (NEET) the syllabus will be Grade 11 Botany,
                                        Zoology, Physics, and Chemistry. <br><br>For Grade 12 (JEE Main, JEE Advanced) the syllabus will be Grade 11
                                        Mathematics, Physics, and
                                        Chemistry. <br><br> For 13 students (NEET) the syllabus will be Grade 11 & 12 Botany,
                                        Zoology, Physics, and
                                        Chemistry. <br><br> For 13 students (JEE Main, JEE Advanced) the syllabus will be Grade 11 & 12
                                        Mathematics, Physics, and
                                        Chemistry.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header cursor-pointer collapsed" data-toggle="collapse" data-target="#collapse13" id="heading13">
                                <h2 class="IL_ilite_faq_q mb-0">
                                    <button type="button" class=" btn-link collapsed" data-toggle="collapse" data-target="#collapse13">What
                                        is the test pattern for ILITE?</button><span class="IL_ilite_faq_exp_icon"></span>
                                </h2>
                            </div>
                            <div id="collapse13" class="collapse" aria-labelledby="heading13" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p>For Grade 9 & 10 students ( Foundation Courses ) the exam pattern is Mathematics will have 45
                                        Questions and
                                        Science has 45 Questions. Each correct answer will be awarded 4 marks. The maximum time to attempt
                                        the exam will be
                                        90 minutes.
                                        <br><br>
                                        For Grade 11 students (NEET & JEE Main, JEE Advanced) the exam pattern is Mathematics will have 45
                                        Questions and
                                        Science has 45 Questions. Each correct answer will be awarded 4 marks. The maximum time to attempt
                                        the exam will be
                                        90 minutes.
                                        <br><br>
                                        For Grade 12 and 13 (NEET) students the exam pattern is Botany has 23 Questions, Zoology
                                        has
                                        22 Questions, Physics has 23 Questions, Chemistry has 22 Questions. Each correct answer will be
                                        awarded 4 marks and
                                        each wrong answer will be penalized with 1 mark. The maximum time to attempt the exam will be
                                        90 minutes.
                                        <br><br>
                                        For Grade 12 and 13 (JEE Main) students the exam pattern is Mathematics 30 Questions, Physics 30 Questions, and Chemistry 30 Questions. Each correct answer will be awarded 4 marks and each wrong answer will be penalized with 1 mark. The maximum time to attempt the exam will be 90 minutes.
                                        <br><br>
                                        For Grade 12 and 13 (JEE Advanced) students the exam pattern is Mathematics has 9 MCQs and 3 Numerical questions, Physics has 9 MCQs and 3 Numerical questions, and Chemistry has 9 MCQs and 3 Numerical questions. Each correct answer will be awarded 4 marks and each wrong MCQ will be penalized with 1 mark. The maximum time to attempt the exam will be 90 minutes.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header cursor-pointer collapsed" data-toggle="collapse" data-target="#collapse14" id="heading14">
                                <h2 class="IL_ilite_faq_q mb-0">
                                    <button type="button" class=" btn-link collapsed" data-toggle="collapse" data-target="#collapse14">What
                                        happens if a person is found to have cheated or engaged in unethical practices in the
                                        test?</button><span class="IL_ilite_faq_exp_icon"></span>
                                </h2>
                            </div>
                            <div id="collapse14" class="collapse" aria-labelledby="heading14" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p>After the results are announced, Infinity Learn goes through if the student has attempted the exam in
                                        an ethical manner for issuing scholarship, if the learner is found to have cheated or engaged in
                                        unethical practices in the test, then Infinity Learn has all the rights to cancel the scholarship
                                        before giving the Notice.</p>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header cursor-pointer collapsed" data-toggle="collapse" data-target="#collapse15" id="heading15">
                                <h2 class="IL_ilite_faq_q mb-0">
                                    <button type="button" class=" btn-link collapsed" data-toggle="collapse" data-target="#collapse15">Is
                                        there any refund policy on the examination fee?</button><span class="IL_ilite_faq_exp_icon"></span>
                                </h2>
                            </div>
                            <div id="collapse15" class="collapse" aria-labelledby="heading15" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p>No. Once the exam fees is paid there is no refund given.</p>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header cursor-pointer collapsed" data-toggle="collapse" data-target="#collapse16" id="heading16">
                                <h2 class="IL_ilite_faq_q mb-0">
                                    <button type="button" class=" btn-link collapsed" data-toggle="collapse" data-target="#collapse16">I
                                        have more queries, What should I do?</button><span class="IL_ilite_faq_exp_icon"></span>
                                </h2>
                            </div>
                            <div id="collapse16" class="collapse" aria-labelledby="heading16" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p>For more queries contact support@infinitylearn.com, +91 9019846666</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </section> 
    <app-footer></app-footer>

    <!-- FAQ js -->
<script>
    $(document).ready(function () {
        // Add minus icon for collapse element which is open by default
        $(".collapse.show").each(function () {
            $(this).prev(".card-header").find(".fa").addClass("fa-minus").removeClass("fa-plus");
        });

        // Toggle plus minus icon on show hide of collapse element
        $(".collapse").on('show.bs.collapse', function () {
            $(this).prev(".card-header").find(".fa").removeClass("fa-plus").addClass("fa-minus");
        }).on('hide.bs.collapse', function () {
            $(this).prev(".card-header").find(".fa").removeClass("fa-minus").addClass("fa-plus");
        });
    });
</script>
